import { render, staticRenderFns } from "./my-points-entry.vue?vue&type=template&id=f33e28ec&scoped=true&lang=pug&"
import script from "./my-points-entry.vue?vue&type=script&lang=js&"
export * from "./my-points-entry.vue?vue&type=script&lang=js&"
import style0 from "./my-points-entry.vue?vue&type=style&index=0&id=f33e28ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33e28ec",
  null
  
)

export default component.exports